import { useCallback } from 'react';
import { featureFlagStore, useSubjectSelector } from '../store';
export var useFeatureFlags = function() {
    var featureFlags = useSubjectSelector(featureFlagStore, [
        'featureFlags'
    ]).featureFlags;
    var setFeatureFlags = useCallback(function(flags) {
        featureFlagStore.setFeatureFlags(flags);
    }, []);
    return {
        featureFlags: featureFlags,
        setFeatureFlags: setFeatureFlags
    };
};
